export interface Adapter<T> {
  adapt(item: any, customOptions?: CustomOptions): T;
}

export interface CustomOptions {
  replaceNewLinesWithBr: boolean;
  withPurchased: boolean;
}
